import { Body, Button, Form, Spacer, TooltipIcon } from '@spritz-finance/ui'
import { SubmitHandler, useFormContext } from 'react-hook-form'
import { Row } from '../../../../../components/Layout/Row'
import { useScreenSize } from '../../../../../context/useScreenSize'
import { PaymentInputWrapper } from '../../directPay/form/amountInput/PaymentInputWrapper'
import { PaymentAmountInput } from '../../directPay/form/PaymentAmountInput'
import { useCreateSubscription } from './create/CreateSubscriptionProvider'
import { PaymentDateSelect } from './PaymentDateSelect'
import { subscriptionAmountValidation } from './subscriptionAmountValidation'
import { USDCBalance } from './USDCBalance'

export type SubscriptionData = {
    amount: number
    day: string
    totalPayments: string
}

const PaymentAmount = () => {
    const { container } = useCreateSubscription()
    const { isMobile } = useScreenSize()
    const {
        formState: { errors },
    } = useFormContext<SubscriptionData>()
    return (
        <>
            <Row>
                <Spacer width={16} />
                <Body.Med size={12} secondary>
                    Recurring payment amount
                </Body.Med>
                <TooltipIcon
                    size={24}
                    side="top"
                    boundary={container}
                    controlled={isMobile}
                    text="You can set any amount here, but the payment will only succeed if the balance is available at time of withdrawal."
                />
            </Row>
            <Spacer height={8} />
            <PaymentInputWrapper error={errors.amount?.message}>
                <PaymentAmountInput validation={subscriptionAmountValidation()} />
            </PaymentInputWrapper>
        </>
    )
}

export const SubscriptionForm = ({
    onFormSubmit,
    initialData,
}: {
    onFormSubmit: SubmitHandler<SubscriptionData>
    initialData: SubscriptionData | null
}) => {
    const initialValues = initialData
        ? initialData
        : { day: '1', amount: undefined, totalPayments: '1' }
    return (
        <Form onSubmit={onFormSubmit} width="100%" initialValues={initialValues}>
            <PaymentAmount />

            <Spacer height={8} />
            <PaymentDateSelect />
            <Spacer height={16} />
            <Spacer height={4} />
            <USDCBalance />
            <Spacer height={8} />

            <Spacer height={32} />
            <Row align="center">
                <Button.CTA type="submit" variant="gradient">
                    Next
                </Button.CTA>
            </Row>
            <Spacer height={24} />
        </Form>
    )
}
